'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utilities = require('@brandfolder/utilities');
var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var useBreakpoints = require('../../../../hooks/use-breakpoints.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
var useRtl = require('../../../../hooks/use-rtl.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var fontIcon$1 = require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
var iconButton = require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const getPagesArray = (fromPage, toPage)=>{
    if (toPage === 1) {
        return [];
    }
    const length = (toPage - fromPage) / 1;
    return Array.from({
        length
    }, (_, i)=>fromPage + i);
};
const UnstyledPagination = (props)=>{
    const { disabled , fontIconProps , iconButtonProps , initial =1 , labels ={
        nextLabel: '',
        previousLabel: ''
    } , loading , locale =utilities.DEFAULT_ISO_LANGUAGE_REGION , onPageChange , total , ...otherProps } = props;
    const { nextLabel , previousLabel  } = labels;
    const { isMd , isSm , isXSm , isXxSm  } = useBreakpoints.useBreakpoints();
    const { isRtl  } = useRtl.useRtl();
    const [current, setCurrent] = React.useState(initial);
    const [iconNext, setIconNext] = React.useState(fontIcon.FontIcons.CaretRight);
    const [iconPrevious, setIconPrevious] = React.useState(fontIcon.FontIcons.CaretLeft);
    const [morePrevious, setMorePrevious] = React.useState(false);
    const [moreNext, setMoreNext] = React.useState(false);
    const [pages, setPages] = React.useState([]);
    const [siblings, setSiblings] = React.useState(1);
    const isCurrentFirst = current === 1;
    const isCurrentLast = current === total;
    const isDisabled = disabled || loading;
    const getPages = ()=>{
        // start at 2 because we always show page 1
        const fromPage = 2;
        // number of first and last buttons
        const boundaries = 1;
        // first and last buttons totalled
        const totalBoundaries = boundaries * 2;
        // siblings (both on left side and right side of current) totalled
        const totalSiblings = siblings * 2;
        const totalBoundariesAndSiblings = totalBoundaries + totalSiblings + 2;
        if (totalBoundariesAndSiblings >= total) {
            setMorePrevious(false);
            setMoreNext(false);
            return getPagesArray(fromPage, total);
        }
        const leftSiblingIndex = Math.max(current - siblings, boundaries);
        const rightSiblingIndex = Math.min(current + siblings, total - boundaries);
        const showMorePrevious = leftSiblingIndex >= boundaries + 2;
        const showMoreNext = rightSiblingIndex <= total - (boundaries + 1);
        setMorePrevious(showMorePrevious);
        setMoreNext(showMoreNext);
        if (!showMorePrevious && showMoreNext) {
            const leftItemCount = totalSiblings + boundaries + 2;
            return getPagesArray(fromPage, leftItemCount);
        }
        if (showMorePrevious && !showMoreNext) {
            const rightItemCount = boundaries + 1 + totalSiblings;
            const fromPage = total - rightItemCount + 1;
            return getPagesArray(fromPage, total);
        }
        return getPagesArray(leftSiblingIndex, rightSiblingIndex + 1);
    };
    React.useEffect(()=>{
        setCurrent(initial);
    }, [
        initial
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        setPages(getPages());
    }, [
        current,
        locale,
        siblings,
        total
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (isMd) {
            setSiblings(4);
        } else if (isSm) {
            setSiblings(3);
        } else if (isXSm) {
            setSiblings(2);
        } else {
            setSiblings(1);
        }
    }, [
        isXxSm,
        isXSm,
        isSm,
        isMd
    ]);
    React.useEffect(()=>{
        if (isRtl) {
            setIconNext(fontIcon.FontIcons.CaretLeft);
            setIconPrevious(fontIcon.FontIcons.CaretRight);
        } else {
            setIconNext(fontIcon.FontIcons.CaretRight);
            setIconPrevious(fontIcon.FontIcons.CaretLeft);
        }
    }, [
        isRtl
    ]);
    const onPage = (page)=>{
        setCurrent(page);
        onPageChange(page);
    };
    const renderNextPrevious = (type)=>{
        const disablePrevious = type === 'previous' && isCurrentFirst;
        const disableNext = type === 'next' && isCurrentLast;
        const disableNextPrevious = isDisabled || disableNext || disablePrevious;
        const icon = type === 'next' ? iconNext : iconPrevious;
        const label = type === 'next' ? nextLabel : previousLabel;
        const page = type === 'next' ? current + 1 : current - 1;
        return /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, iconButtonProps, {
            className: classnames__default.default({
                [`bf-pagination__${type}`]: true,
                [`bf-pagination__${type}--disabled`]: disableNextPrevious,
                [`${iconButtonProps?.className}`]: !!iconButtonProps?.className
            }),
            disabled: disableNextPrevious,
            icon: icon,
            label: label,
            look: button.ButtonLooks.Default,
            onClick: disableNextPrevious ? undefined : ()=>onPage(page),
            onKeyUp: (e)=>{
                if (e.key === 'Enter' && !disableNextPrevious) {
                    onPage(page);
                }
            }
        }));
    };
    const renderPage = (page)=>{
        const isCurrentPage = current === page;
        const isFirst = page === 1;
        const isLast = page === total;
        const look = isCurrentPage ? button.ButtonLooks.Primary : button.ButtonLooks.Tertiary;
        const pageLocalized = page.toLocaleString(locale);
        return /*#__PURE__*/ React__default.default.createElement(iconButton.IconButton, _extends({}, iconButtonProps, {
            "aria-current": isCurrentPage || undefined,
            className: classnames__default.default({
                'bf-pagination__page': true,
                'bf-pagination__page--current': isCurrentPage,
                'bf-pagination__page--disabled': isDisabled,
                'bf-pagination__page--first': isFirst,
                'bf-pagination__page--last': isLast,
                [`${iconButtonProps?.className}`]: !!iconButtonProps?.className
            }),
            disabled: isDisabled,
            key: page,
            label: pageLocalized,
            look: look,
            onClick: !isCurrentPage && !isDisabled ? ()=>onPage(page) : undefined,
            onKeyUp: (e)=>{
                if (e.key === 'Enter' && !isCurrentPage && !isDisabled) {
                    onPage(page);
                }
            }
        }), pageLocalized);
    };
    const renderPages = ()=>{
        return pages.map((page)=>renderPage(page));
    };
    const renderFirst = ()=>{
        return renderPage(1);
    };
    const renderLast = ()=>{
        return total > 1 ? renderPage(total) : null;
    };
    const renderMore = ()=>{
        return /*#__PURE__*/ React__default.default.createElement(fontIcon$1.FontIcon, _extends({}, fontIconProps, {
            "aria-hidden": true,
            className: classnames__default.default({
                'bf-pagination__more': true,
                [`${fontIconProps?.className}`]: !!fontIconProps?.className
            }),
            icon: fontIcon.FontIcons.Ellipsis
        }));
    };
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-pagination': true,
            'bf-pagination__standard': true,
            'bf-pagination__standard--disabled': disabled,
            [`${otherProps?.className}`]: !!otherProps?.className
        })
    }), renderNextPrevious('previous'), renderFirst(), morePrevious && renderMore(), renderPages(), moreNext && renderMore(), renderLast(), renderNextPrevious('next'));
};
const StyledPagination = styled__default.default(UnstyledPagination)`
  display: flex;
  flex-wrap: wrap;

  .bf-button__icon {
    border-radius: 2px;
    font-size: 14px;
    height: 32px;
    margin: 3px;
    min-height: 0;
    min-width: 32px;
    padding-left: 7px;
    padding-right: 7px;
  }

  .bf-button__font-icon {
    font-size: 12px;
  }

  .bf-pagination__more {
    align-items: center;
    color: ${({ theme  })=>theme.text.default};
    display: flex;
    height: 32px;
    justify-content: center;
    margin: 3px;
    width: 32px;
  }

  .bf-pagination__page {
    font-variant-numeric: tabular-nums;
  }

  .bf-pagination__page--current {
    background-color: ${({ theme  })=>theme.button.primary.backgroundColor};
    border-color: ${({ theme  })=>theme.button.primary.borderColor};
    color: ${({ theme  })=>theme.button.primary.textColor};
    cursor: default;

    &[aria-disabled='true'] {
      background-color: ${({ theme  })=>theme.button.primary.backgroundColorDisabled};
      border-color: ${({ theme  })=>theme.button.primary.borderColorDisabled};
      color: ${({ theme  })=>theme.button.primary.textColorDisabled};
    }
  }
`;
/**
 * Pagination allows a user to move between pages of content such as search results.
 * Note that this pagination component uses `<button>` tags (it does not use `<a>` tags to change the URL).
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/Layout_cookbook/Pagination
 *
 *
 * @param props StandardPaginationProps
 * @returns FunctionComponent<StandardPaginationProps>
 */ const StandardPagination = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledPagination, _extends({}, props)));
};

exports.StandardPagination = StandardPagination;
//# sourceMappingURL=standard-pagination.js.map
